import "./card.style.scss";

const Card = ({
  className = "one",
  title = "Card One",
  content = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
  buttonText = "Read more",
  buttonClick = () => undefined,
  cardStyle = {
    backgroundLine: "linear-gradient(45deg, #f0bc02, #fa0a50)",
    skew: "skew(20deg)",
  },
}) => {
  return (
    <div className="card-container">
      <div
        className={`card-bg ${className}`}
        style={{
          background: cardStyle.backgroundLine,
          transform: cardStyle.skew,
          "&::after": { background: cardStyle.backgroundLine },
        }}
      ></div>
      <div className="card-block">
        <div className="card-content">
          <h3>{title}</h3>
          <p>{content}</p>
          <button onClick={() => buttonClick()}>{buttonText}</button>
        </div>
      </div>
    </div>
  );
};

export default Card;
